import "./App.scss";
import { Switch, Route, withRouter } from "react-router-dom";
import Home from "./pages/home/Home";
import Gallery from "./pages/gallery/Gallery";
import ZoomedImage from "./pages/zoomedImage/ZoomedImage";
import CustomQuote from "./pages/customQuote/CustomQuote";
import AdminRequest from "./pages/adminRequest/AdminRequest";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Reviews from "./pages/reviews/Reviews";
// import Staples from "./pages/staples/Staples";
import AdminLogin from "./pages/adminLogin/AdminLogin";
import AdminUpload from "./pages/adminUpload/AdminUpload";
import AdminDash from "./pages/adminDash/AdminDash";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import { Fragment } from "react";
import EditImage from "./pages/editImage/EditImage";
import RequestSent from "./components/RequestSent/RequestSent";
import Shopping from "./pages/shopping/Shopping";

function App() {
  return (
    <div className="app">
      <Fragment>
        <Header />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/gallery" exact component={Gallery} />
          <Route path="/gallery/:id" exact component={ZoomedImage} />
          <Route path="/gallery/:id/edit" exact component={EditImage} />
          <Route path="/quotes" component={CustomQuote} />
          <Route path="/reviews" component={Reviews} />
          <Route path="/staples" component={Shopping} />
          <PrivateRoute path="/admin/request" component={AdminRequest} />
          <Route path="/login" component={AdminLogin} />
          <PrivateRoute path="/admin/upload" component={AdminUpload} />
          <PrivateRoute path="/admin" exact component={AdminDash} />
          <Route path="/sent" component={RequestSent} />
        </Switch>
        <Footer />
      </Fragment>
    </div>
  );
}

export default withRouter(App);
